module.exports = __webpack_public_path__ + "img/hollandaise.ea26fa13.png";